import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { Label, Section } from 'jbc-front/components/Form';
import { getItem } from 'src/reducers/common/itemReducer';
import selector, { numToStr, getOptionLabel, employeeDisplay, display, currency } from 'src/utils/Utils';
import { getSelectOptions, getRadioOptions } from 'src/reducers/selectOptions';
import { Checked } from 'src/icons';
import tableStyles from '../styles/GeneralTableInfo.scss';
import { useTranslation } from 'react-i18next';

const SeparatedOverseaMoney = ({ employeeFamilySupport }) => {
  const { t } = useTranslation();
  return (
    <div>
      <table className={tableStyles.mTablePersonal}>
        <tbody>
          <tr>
            <th />
            <td />
          </tr>
          <tr>
            <th>{t('features.Employees.components.FamilySupportSectionShow.Remittance_to_relatives_living_abroad')}</th>
            <td>{currency(numToStr(employeeFamilySupport.overseaSendingMoneyAmount))}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const addressFor = (support, employee, prefectures) => {
  switch (support.residentType) {
    case 'together':
      return employeeDisplay.address(employee, prefectures);
    case 'separated_domestic':
      return employeeDisplay.familyAddress(support, prefectures);
    case 'separated_oversea':
      return _.get(support, 'overseaAddress');
    default:
      return '';
  }
};

let FamilySupportItem = props => {
  const {
    employeeFamilySupport,
    index,
    relationshipTypes,
    genders,
    residentTypes,
    disabledPersonTypes,
    employee,
    prefectures
  } = props;
  const { t, i18n } = useTranslation();

  return (
    <div>
      <Section title={t('features.Employees.components.FamilySupportsSectionShow.dependent_information') + `${index + 1}`}>
        <table className={tableStyles.mTablePersonal}>
          <tbody>
            <tr>
              <th>{t('features.Employees.components.FamilySupportsSectionShow.Relationship')}：</th>
              <td>
                {employeeFamilySupport.relationshipType === 'other'
                  ? employeeFamilySupport.relationshipDetail
                  : getOptionLabel(employeeFamilySupport.relationshipType)(relationshipTypes)}
              </td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FamilySupportsSectionShow.Name')}：</th>
              <td>{employeeDisplay.fullName(employeeFamilySupport, i18n)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FamilySupportsSectionShow.Birthdate')}：</th>
              <td>{employeeDisplay.birthday(employeeFamilySupport)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FamilySupportsSectionShow.Gender')}：</th>
              <td>{display(getOptionLabel(employeeFamilySupport.gender)(genders))}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FamilySupportsSectionShow.Cohabit_Separate')}：</th>
              <td>{display(getOptionLabel(employeeFamilySupport.residentType)(residentTypes))}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FamilySupportsSectionShow.Address')}：</th>
              <td>{display(addressFor(employeeFamilySupport, employee, prefectures))}</td>
            </tr>
          </tbody>
        </table>

        {employeeFamilySupport.residentType === 'separated_oversea' && (
          <SeparatedOverseaMoney {...{ employeeFamilySupport }} />
        )}

        <table className={tableStyles.mTablePersonal}>
          <tbody>
            <tr>
              <th />
              <td />
            </tr>
            <tr>
              <th>{t('features.Employees.components.FamilySupportsSectionShow.annual_revenue_Jan_Dec')}</th>
              <td>{currency(numToStr(employeeFamilySupport.yearlyIncome))}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FamilySupportsSectionShow.annual_taxable_income_Jan_Dec')}</th>
              <td>{currency(numToStr(employeeFamilySupport.yearlyEarning))}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FamilySupportsSectionShow.handicapped_division')}</th>
              <td>{getOptionLabel(employeeFamilySupport.disabledPersonType)(disabledPersonTypes)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.FamilySupportsSectionShow.tax_dependent')}</th>
              <td>
                <Checked checked={employeeFamilySupport.isTaxDependency} />
              </td>
            </tr>
          </tbody>
        </table>
      </Section>
    </div>
  );
};

FamilySupportItem = connect(state => ({
  relationshipTypes: getRadioOptions(state, 'relationshipTypes'),
  prefectures: getSelectOptions(state, 'prefectures'),
  employee: selector(getItem(REDUCER_NAME, state), 'employee'),
  genders: getRadioOptions(state, 'genders'),
  residentTypes: getRadioOptions(state, 'residentTypes'),
  disabledPersonTypes: getRadioOptions(state, 'disabledPersonTypes')
}))(FamilySupportItem);

const FamilySupportsSectionShow = ({ employeeFamilySupports, countDependents }) => {
  return (
    <div>
      {/* <table className={tableStyles.mTablePersonal}>
        <tbody>
          <tr>
            <th>
              <Label
                text={t('features.Employees.components.FamilySupportsSectionShow.Number_of_dependents')}
                noteWidth={500}
                note="「扶養親族等の数」は、「扶養情報」と、「税区分」の寡婦（夫）/障害/勤労学生をもとに自動計算されます。
            （「税の扶養対象」でチェックが外れている扶養情報はカウントされません）
            詳細の計算方法は国税庁のサイトをご覧ください。"
              />
            </th>
            <td>{countDependents}人</td>
          </tr>
        </tbody>
      </table> */}
      <div className="u-mt30">
        {employeeFamilySupports.map((item, index) => (
          <FamilySupportItem employeeFamilySupport={item} key={item.id} index={index} />
        ))}
      </div>
    </div>
  );
};

export default connect(state => ({
  employeeFamilySupports: selector(getItem(REDUCER_NAME, state), 'employeeFamilySupports') || [],
  countDependents: selector(getItem(REDUCER_NAME, state), 'countDependents')
}))(FamilySupportsSectionShow);
